import { NgModule, ModuleWithProviders, Injector } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { EpBtFieldAgentControlsComponent } from './ep-bt-field-agent-controls.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { EpbtFaStateListComponent } from './list/epbt-fa-state-list/epbt-fa-state-list.component';
import { EpbtFaCountryListComponent } from './list/epbt-fa-country-list/epbt-fa-country-list.component';
import { EpbtFaSalesrepListComponent } from './list/epbt-fa-salesrep-list/epbt-fa-salesrep-list.component';
import { EpbtFaSalesareaListComponent } from './list/epbt-fa-salesarea-list/epbt-fa-salesarea-list.component';
import { EpbtFaDeliveryareaListComponent } from './list/epbt-fa-deliveryarea-list/epbt-fa-deliveryarea-list.component';
import { EpbtFaDocumenttypeListComponent } from './list/epbt-fa-documenttype-list/epbt-fa-documenttype-list.component';
import { EpCore2Module, EpCardModule, EpLabelModule, EpButtonsModule, EpDateInputsModule, EpCheckBoxModule, EpInputsModule, EpTreeViewModule, EpGridModule, EpLayoutModule, EpDropdownsModule, EpSearchBoxModule, EpUploadModule, EpSignatureModule, EpRadioButtonModule, EpPanelbarComponent, EpToolTipModule } from '@epicor/kinetic';
import { EpbtFaDocumentsGridComponent } from './controls/epbt-fa-documents-grid/epbt-fa-documents-grid.component';
import { EpbtFaDocumentGridCardComponent } from './controls/epbt-fa-document-grid-card/epbt-fa-document-grid-card.component';
import { EpbtFaAddressGridComponent } from './controls/epbt-fa-address-grid/epbt-fa-address-grid.component';
import { EpbtFaCustomerGridComponent } from './controls/epbt-fa-customer-grid/epbt-fa-customer-grid.component';
import { EpbtFaCustomerSearchComponent } from './controls/epbt-fa-customer-search/epbt-fa-customer-search.component';
import { API_BASE_URL, EpBtFieldAgentProxyModule } from 'ep-bt-field-agent-proxy';
import { ServiceConfig } from 'ep-bt-controls';
import { EpbtFaAddressInfoCardComponent } from './controls/epbt-fa-address-info-card/epbt-fa-address-info-card.component';
import { EpbtFaAddressInfoMapCardComponent } from './controls/epbt-fa-address-info-map-card/epbt-fa-address-info-map-card.component';
import { EpbtFaContactsGridComponent } from './controls/epbt-fa-contacts-grid/epbt-fa-contacts-grid.component';
import { EpbtFaNotepadGridComponent } from './controls/epbt-fa-notepad-grid/epbt-fa-notepad-grid.component';
import { EpbtFaCustomerProductsPurchasedGridComponent } from './controls/epbt-fa-customer-products-purchased-grid/epbt-fa-customer-products-purchased-grid.component';
import { EpbtFaCustomerFinancialDetailsComponent } from './controls/epbt-fa-customer-financial-details/epbt-fa-customer-financial-details.component';
import { EpbtFaNotepadtypeListComponent } from './list/epbt-fa-notepadtype-list/epbt-fa-notepadtype-list.component';
import { EpbtFaCustomerProductsPurchasedDetailsComponent } from './controls/epbt-fa-customer-products-purchased-details/epbt-fa-customer-products-purchased-details.component';
import { EpbtFaCustomerJobBalancesGridComponent } from './controls/epbt-fa-customer-job-balances-grid/epbt-fa-customer-job-balances-grid.component';
import { EpbtFaBistrackuserListComponent } from './list/epbt-fa-bistrackuser-list/epbt-fa-bistrackuser-list.component';
import { EpbtFaCustomerCampaignsListComponent } from './list/epbt-fa-customer-campaigns-list/epbt-fa-customer-campaigns-list.component';
import { EpbtFaCustomerContactListComponent } from './list/epbt-fa-customer-contact-list/epbt-fa-customer-contact-list.component';
import { EpbtFaCampaignActionListComponent } from './list/epbt-fa-campaign-action-list/epbt-fa-campaign-action-list.component';
import { EpbtFaTitleListComponent } from './list/epbt-fa-title-list/epbt-fa-title-list.component';
import { EpbtFaCustomerDocOppStatusListComponent } from './list/epbt-fa-customer-doc-opp-status-list/epbt-fa-customer-doc-opp-status-list.component';
import { EpbtFaCustomerDocOppCurrencyListComponent } from './list/epbt-fa-customer-doc-opp-currency-list/epbt-fa-customer-doc-opp-currency-list.component';
import { EpbtFaDocumentLineComponent } from './controls/epbt-fa-document-line/epbt-fa-document-line.component';
import { EpbtFaAttachmentComponent } from './controls/epbt-fa-attachment/epbt-fa-attachment.component';
import { EpbtFaProductGridComponent } from './controls/epbt-fa-product-grid/epbt-fa-product-grid.component';
import { EpbtFaProductInfoComponent } from './controls/epbt-fa-product-info/epbt-fa-product-info.component';
import { EpbtFaProductPurchasedByGridComponent } from './controls/epbt-fa-product-purchased-by-grid/epbt-fa-product-purchased-by-grid.component';
import { EpbtFaProductSellingBandsGridComponent } from './controls/epbt-fa-product-selling-bands-grid/epbt-fa-product-selling-bands-grid.component';
import { EpbtFaProductStockGridComponent } from './controls/epbt-fa-product-stock-grid/epbt-fa-product-stock-grid.component';
import { EpbtFaProductBinlocationGridComponent } from './controls/epbt-fa-product-binlocation-grid/epbt-fa-product-binlocation-grid.component';
import { EpbtFaProductBinlocationComponent } from './controls/epbt-fa-product-binlocation/epbt-fa-product-binlocation.component';
import { EpbtFaBistrackbranchesListComponent } from './list/epbt-fa-bistrackbranches-list/epbt-fa-bistrackbranches-list.component';
import { EpbtFaProductRelatedGridComponent } from './controls/epbt-fa-product-related-grid/epbt-fa-product-related-grid.component';
import { EpbtFaBinLocationProductGridComponent } from './controls/epbt-fa-bin-location-product-grid/epbt-fa-bin-location-product-grid.component';
import { EpbtFaBinLocationSelectedProductGridComponent } from './controls/epbt-fa-bin-location-selected-product-grid/epbt-fa-bin-location-selected-product-grid.component';
import { EpbtFaBinLocationSummaryComponent } from './controls/epbt-fa-bin-location-summary/epbt-fa-bin-location-summary.component';
import { EpbtFaQuickOrderQuoteComponent } from './controls/epbt-fa-quick-order-quote/epbt-fa-quick-order-quote.component';
import { EpbtFaTaxAreasListComponent } from './list/epbt-fa-tax-areas-list/epbt-fa-tax-areas-list.component';
import { EpbtFaSuppliersGridComponent } from './controls/epbt-fa-suppliers-grid/epbt-fa-suppliers-grid.component';
import { EpbtFaQuickPurchaseSuppliersComponent } from './controls/epbt-fa-quick-purchase-suppliers/epbt-fa-quick-purchase-suppliers.component';
import { EpbtFaQuickTransferSelectedProductsGridComponent } from './controls/epbt-fa-quick-transfer-selected-products-grid/epbt-fa-quick-transfer-selected-products-grid.component';
import { EpbtFaProductStockDetailsComponent } from './controls/epbt-fa-product-stock-details/epbt-fa-product-stock-details.component';
import { EpbtFaImageDialogComponent } from './dialogs/epbt-fa-image-dialog/epbt-fa-image-dialog.component';
import { EpbtFaCompetitorPricingComponent } from './controls/epbt-fa-competitor-pricing/epbt-fa-competitor-pricing.component';
import { EpbtFaCompetitorPriceAddressListComponent } from './list/epbt-fa-competitor-price-address-list/epbt-fa-competitor-price-address-list.component';
import { EpbtFaCompetitorPriceTypeListComponent } from './list/epbt-fa-competitor-price-type-list/epbt-fa-competitor-price-type-list.component';
import { EpbtFaQuickPurchaseSelectedProductGridComponent } from './controls/epbt-fa-quick-purchase-selected-product-grid/epbt-fa-quick-purchase-selected-product-grid.component';
import { EpbtFaProductPerListComponent } from './list/epbt-fa-product-per-list/epbt-fa-product-per-list.component';
import { EpbtFaCompetitorSelectedProductGridComponent } from './controls/epbt-fa-competitor-selected-product-grid/epbt-fa-competitor-selected-product-grid.component';
import { EpbtFaCompetitorNegotiationListComponent } from './list/epbt-fa-competitor-negotiation-list/epbt-fa-competitor-negotiation-list.component';
import { EpbtFaQuickPurchaseSummaryComponent } from './controls/epbt-fa-quick-purchase-summary/epbt-fa-quick-purchase-summary.component';
import { EpbtFaAddressesGridComponent } from './controls/epbt-fa-addresses-grid/epbt-fa-addresses-grid.component';
import { EpbtFaQuickOrderQuoteSelectedProductGridComponent } from './controls/epbt-fa-quick-order-quote-selected-product-grid/epbt-fa-quick-order-quote-selected-product-grid.component';
import { EpbtFaProductQuantityControlComponent } from './controls/epbt-fa-product-quantity-control/epbt-fa-product-quantity-control.component';
import { EpbtFaQuickOrderTalliedProductLineNegotiationComponent } from './controls/epbt-fa-quick-order-tallied-product-line-negotiation/epbt-fa-quick-order-tallied-product-line-negotiation.component';
import { EpbtFaQuickOrderMOLTNegotiationComponent } from './controls/epbt-fa-quick-order-molt-negotiation/epbt-fa-quick-order-molt-negotiation.component';
import { EpbtFaQuickOrderLineNegotiationComponent } from './controls/epbt-fa-quick-order-line-negotiation/epbt-fa-quick-order-line-negotiation.component';
import { EpbtFaCompetitorSummaryComponent } from './controls/epbt-fa-competitor-summary/epbt-fa-competitor-summary.component';
import { EpbtFaPerListComponent } from './list/epbt-fa-per-list/epbt-fa-per-list.component';

import { EpbtFaProductTalliedQuantityControlComponent } from './controls/epbt-fa-product-tallied-quantity-control/epbt-fa-product-tallied-quantity-control.component';
import { EpbtFaCustomerInfoComponent } from './controls/epbt-fa-customer-info/epbt-fa-customer-info.component';
import { EpBtControlsModule } from 'ep-bt-controls';
import { EpbtFaQuickTransferSummaryComponent } from './controls/epbt-fa-quick-transfer-summary/epbt-fa-quick-transfer-summary.component';
import { EpbtFaLabelRequestComponent } from './controls/epbt-fa-label-request/epbt-fa-label-request.component';
import { EpbtFaLabelTemplatesGridComponent } from './controls/epbt-fa-label-templates-grid/epbt-fa-label-templates-grid.component';
import { EpbtFaLabelSelectedProductsGridComponent } from './controls/epbt-fa-label-selected-products-grid/epbt-fa-label-selected-products-grid.component';
import { EpbtFaCompetitorPricingLineNegotiationComponent } from './controls/epbt-fa-competitor-pricing-line-negotiation/epbt-fa-competitor-pricing-line-negotiation.component';
import { EpbtFaQuickTransferSummaryProductsGridComponent } from './controls/epbt-fa-quick-transfer-summary-products-grid/epbt-fa-quick-transfer-summary-products-grid.component';
import { EpbtFaQuickPurchaseSummaryProductsGridComponent } from './controls/epbt-fa-quick-purchase-summary-products-grid/epbt-fa-quick-purchase-summary-products-grid.component';
import { EpbtFaProductFilesGridComponent } from './controls/epbt-fa-product-files-grid/epbt-fa-product-files-grid.component';
import { NoCommaPipe } from './pipes/no-comma.pipe';
import { EpbtFaQuickOrderSummaryComponent } from './controls/epbt-fa-quick-order-summary/epbt-fa-quick-order-summary.component';
import { EpbtFaLabelSummaryComponent } from './controls/epbt-fa-label-summary/epbt-fa-label-summary.component';
import { EpbtFaDashboardOpportunitiesGridComponent } from './controls/epbt-fa-dashboard-opportunities-grid/epbt-fa-dashboard-opportunities-grid.component';
import { EpbtFaLabelSummaryTemplatesGridComponent } from './controls/epbt-fa-label-summary-templates-grid/epbt-fa-label-summary-templates-grid.component';
import { EpbtFaCalendarComponent } from './controls/epbt-fa-calendar/epbt-fa-calendar.component';
import { SchedulerModule } from '@progress/kendo-angular-scheduler';
import { EpbtFaSmartviewsComponent } from './controls/epbt-fa-smartviews/epbt-fa-smartviews.component';
import { EpbtFaQuickOrderEmailComponent } from './controls/epbt-fa-quick-order-email/epbt-fa-quick-order-email.component';
import { KeyValuePipePipe } from './pipes/key-value-pipe.pipe';
import { EpbtFaSmartviewsGridComponent } from './controls/epbt-fa-smartviews-grid/epbt-fa-smartviews-grid.component';
import { EpbtFaSmartTilesComponent } from './controls/epbt-fa-smart-tiles/epbt-fa-smart-tiles.component';
import { EpbtFaSmartviewsDetailsComponent } from './controls/epbt-fa-smartviews-details/epbt-fa-smartviews-details.component';
import { EpbtFaLabelSummaryProductsGridComponent } from './controls/epbt-fa-label-summary-products-grid/epbt-fa-label-summary-products-grid.component';
import { EpbtFaSmartTilesDetailsComponent } from './controls/epbt-fa-smart-tiles-details/epbt-fa-smart-tiles-details.component';
import { EpbtFaFilterControlComponent } from './controls/epbt-fa-filter-control/epbt-fa-filter-control.component';
import { EpbtFaDocumentSourceMaterialGridComponent } from './controls/epbt-fa-document-source-material-grid/epbt-fa-document-source-material-grid.component';
import { EpbtFaDocumentProcessesGridComponent } from './controls/epbt-fa-document-processes-grid/epbt-fa-document-processes-grid.component';
import { EpbtFaDocumentFinishedProductsGridComponent } from './controls/epbt-fa-document-finished-products-grid/epbt-fa-document-finished-products-grid.component';
import { EpbtFaSortControlComponent } from './controls/epbt-fa-sort-control/epbt-fa-sort-control.component';
import { EpbtFaRightSideBarComponent } from './controls/epbt-fa-right-side-bar/epbt-fa-right-side-bar.component';
import { EpbtFaSortListComponent } from './list/epbt-fa-sort-list/epbt-fa-sort-list.component';
import { EpbtFaNewQuickOrderCustomerComponent } from './controls/epbt-fa-new-quick-order-customer/epbt-fa-new-quick-order-customer.component';
import { EpbtFaNewQuickOrderProductComponent } from './controls/epbt-fa-new-quick-order-product/epbt-fa-new-quick-order-product.component';
import { EpbtFaNewQuickOrderCustomerDetailsComponent } from './controls/epbt-fa-new-quick-order-customer-details/epbt-fa-new-quick-order-customer-details.component';
import { EpbtFaNewQuickOrderProductDetailsComponent } from './controls/epbt-fa-new-quick-order-product-details/epbt-fa-new-quick-order-product-details.component';
import { EpbtFaNewQuickOrderDetailsComponent } from './controls/epbt-fa-new-quick-order-details/epbt-fa-new-quick-order-details.component';
import { EpbtFaNewQuickOrderOperationsComponent } from './controls/epbt-fa-new-quick-order-operations/epbt-fa-new-quick-order-operations.component';
import { EpbtFaSaleTypeListComponent } from './list/epbt-fa-sale-type-list/epbt-fa-sale-type-list.component';
import { MatTabsModule } from '@angular/material/tabs';
import { EpbtFieldAgentService } from './services/epbt-field-agent.service';
import { EpbtFaProductDialogComponent } from './dialogs/epbt-fa-product-dialog/epbt-fa-product-dialog.component';
import { EpbtFaOpenDocumentComponent } from './controls/epbt-fa-open-document/epbt-fa-open-document.component';

// import {InjectorInstance} from './app.module';

export let InjectorInstance: Injector;
export function serviceConfig_CloudApiEndpoint() {
    const serviceConfig = InjectorInstance.get<ServiceConfig>(ServiceConfig);
    return serviceConfig.CloudApiEndpoint;
}

@NgModule({
    imports: [
        CarouselModule,
        BrowserAnimationsModule,
        MatTabsModule,
        EpCore2Module,
        FormsModule,
        CommonModule,
        EpCardModule,
        EpLabelModule,
        EpButtonsModule,
        EpDateInputsModule,
        EpCheckBoxModule,
        EpInputsModule,
        EpTreeViewModule,
        EpGridModule,
        EpLayoutModule,
        EpCheckBoxModule,
        EpDropdownsModule,
        EpSearchBoxModule,
        EpSignatureModule,
        EpUploadModule,
        EpRadioButtonModule,
        EpBtControlsModule,
        ReactiveFormsModule,
        EpBtFieldAgentProxyModule,
        BrowserModule,
        SchedulerModule,
        EpToolTipModule
    ],
    declarations: [

        EpBtFieldAgentControlsComponent,
        EpbtFaDocumenttypeListComponent,
        EpbtFaDocumentsGridComponent,
        EpbtFaDocumentGridCardComponent,
        EpbtFaStateListComponent,
        EpbtFaCountryListComponent,
        EpbtFaSalesrepListComponent,
        EpbtFaSalesareaListComponent,
        EpbtFaDeliveryareaListComponent,
        EpbtFaAddressGridComponent,
        EpbtFaCustomerGridComponent,
        EpbtFaCustomerSearchComponent,
        EpbtFaAddressInfoCardComponent,
        EpbtFaAddressInfoMapCardComponent,
        EpbtFaContactsGridComponent,
        EpbtFaNotepadGridComponent,
        EpbtFaCustomerProductsPurchasedGridComponent,
        EpbtFaCustomerFinancialDetailsComponent,
        EpbtFaNotepadtypeListComponent,
        EpbtFaCustomerProductsPurchasedDetailsComponent,
        EpbtFaCustomerJobBalancesGridComponent,
        EpbtFaBistrackuserListComponent,
        EpbtFaCustomerCampaignsListComponent,
        EpbtFaCustomerContactListComponent,
        EpbtFaCampaignActionListComponent,
        EpbtFaTitleListComponent,
        EpbtFaCustomerDocOppStatusListComponent,
        EpbtFaCustomerDocOppCurrencyListComponent,
        EpbtFaDocumentLineComponent,
        EpbtFaAttachmentComponent,
        EpbtFaProductGridComponent,
        EpbtFaProductInfoComponent,
        EpbtFaProductPurchasedByGridComponent,
        EpbtFaProductSellingBandsGridComponent,
        EpbtFaProductStockGridComponent,
        EpbtFaProductBinlocationGridComponent,
        EpbtFaProductBinlocationComponent,
        EpbtFaBistrackbranchesListComponent,
        EpbtFaProductPurchasedByGridComponent,
        EpbtFaProductRelatedGridComponent,
        EpbtFaBinLocationProductGridComponent,
        EpbtFaBinLocationSelectedProductGridComponent,
        EpbtFaBinLocationSummaryComponent,
        EpbtFaSuppliersGridComponent,
        EpbtFaQuickOrderQuoteComponent,
        EpbtFaTaxAreasListComponent,
        EpbtFaQuickPurchaseSuppliersComponent,
        EpbtFaQuickTransferSelectedProductsGridComponent,
        EpbtFaProductStockDetailsComponent,
        EpbtFaImageDialogComponent,
        EpbtFaCompetitorPricingComponent,
        EpbtFaCompetitorPriceAddressListComponent,
        EpbtFaCompetitorPriceTypeListComponent,
        EpbtFaQuickPurchaseSelectedProductGridComponent,
        EpbtFaCompetitorSelectedProductGridComponent,
        EpbtFaCompetitorNegotiationListComponent,
        EpbtFaProductPerListComponent,
        EpbtFaQuickPurchaseSummaryComponent,
        EpbtFaAddressesGridComponent,
        EpbtFaQuickOrderQuoteSelectedProductGridComponent,
        EpbtFaProductQuantityControlComponent,
        EpbtFaQuickOrderTalliedProductLineNegotiationComponent,
        EpbtFaQuickOrderMOLTNegotiationComponent,
        EpbtFaQuickOrderLineNegotiationComponent,
        EpbtFaCompetitorSummaryComponent,
        EpbtFaPerListComponent,
        EpbtFaProductTalliedQuantityControlComponent,
        EpbtFaCustomerInfoComponent,
        EpbtFaQuickTransferSummaryComponent,
        EpbtFaLabelRequestComponent,
        EpbtFaLabelTemplatesGridComponent,
        EpbtFaLabelSelectedProductsGridComponent,
        EpbtFaCompetitorPricingLineNegotiationComponent,
        EpbtFaQuickTransferSummaryProductsGridComponent,
        EpbtFaQuickPurchaseSummaryProductsGridComponent,
        EpbtFaProductFilesGridComponent,
        NoCommaPipe,
        EpbtFaQuickOrderSummaryComponent,
        EpbtFaLabelSummaryComponent,
        EpbtFaDashboardOpportunitiesGridComponent,
        EpbtFaLabelSummaryTemplatesGridComponent,
        EpbtFaCalendarComponent,
        EpbtFaSmartviewsComponent,
        EpbtFaQuickOrderEmailComponent,
        KeyValuePipePipe,
        EpbtFaSmartviewsGridComponent,
        EpbtFaSmartTilesComponent,
        EpbtFaSmartviewsDetailsComponent,
        EpbtFaLabelSummaryProductsGridComponent,
        EpbtFaSmartTilesDetailsComponent,
        EpbtFaFilterControlComponent,

        EpbtFaDocumentSourceMaterialGridComponent,
        EpbtFaDocumentProcessesGridComponent,
        EpbtFaDocumentFinishedProductsGridComponent,
        EpbtFaSortControlComponent,
        EpbtFaRightSideBarComponent,
        EpbtFaSortListComponent,
        EpbtFaNewQuickOrderCustomerComponent,
        EpbtFaNewQuickOrderProductComponent,
        EpbtFaNewQuickOrderCustomerDetailsComponent,
        EpbtFaNewQuickOrderProductDetailsComponent,
        EpbtFaNewQuickOrderDetailsComponent,
        EpbtFaNewQuickOrderOperationsComponent,
        EpbtFaSaleTypeListComponent,
        EpbtFaProductDialogComponent,
        EpbtFaOpenDocumentComponent
    ],
    exports: [EpBtFieldAgentControlsComponent,
        EpbtFaDocumenttypeListComponent,
        EpbtFaDocumentsGridComponent,
        EpbtFaDocumentGridCardComponent,
        EpbtFaStateListComponent,
        EpbtFaCountryListComponent,
        EpbtFaSalesrepListComponent,
        EpbtFaSalesareaListComponent,
        EpbtFaDeliveryareaListComponent,
        EpbtFaAddressGridComponent,
        EpbtFaCustomerGridComponent,
        EpbtFaCustomerSearchComponent,
        EpbtFaAddressInfoCardComponent,
        EpbtFaAddressInfoMapCardComponent,
        EpbtFaContactsGridComponent,
        EpbtFaCustomerProductsPurchasedGridComponent,
        EpbtFaCustomerFinancialDetailsComponent,
        EpbtFaNotepadGridComponent,
        EpbtFaCustomerProductsPurchasedDetailsComponent,
        EpbtFaCustomerJobBalancesGridComponent,
        EpbtFaNotepadtypeListComponent,
        EpbtFaBistrackuserListComponent,
        EpbtFaCustomerCampaignsListComponent,
        EpbtFaCustomerContactListComponent,
        EpbtFaCampaignActionListComponent,
        EpbtFaTitleListComponent,
        EpbtFaCustomerDocOppStatusListComponent,
        EpbtFaCustomerDocOppCurrencyListComponent,
        EpbtFaDocumentLineComponent,
        EpbtFaAttachmentComponent,
        EpbtFaProductGridComponent,
        EpbtFaProductInfoComponent,
        EpbtFaProductPurchasedByGridComponent,
        EpbtFaProductSellingBandsGridComponent,
        EpbtFaProductStockGridComponent,
        EpbtFaProductBinlocationGridComponent,
        EpbtFaProductBinlocationComponent,
        EpbtFaBistrackbranchesListComponent,
        EpbtFaProductPurchasedByGridComponent,
        EpbtFaProductRelatedGridComponent,
        EpbtFaBinLocationProductGridComponent,
        EpbtFaBinLocationSelectedProductGridComponent,
        EpbtFaBinLocationSummaryComponent,
        EpbtFaSuppliersGridComponent,
        EpbtFaQuickOrderQuoteComponent,
        EpbtFaTaxAreasListComponent,
        EpbtFaQuickPurchaseSuppliersComponent,
        EpbtFaQuickTransferSelectedProductsGridComponent,
        EpbtFaProductStockDetailsComponent,
        EpbtFaImageDialogComponent,
        EpbtFaCompetitorPricingComponent,
        EpbtFaCompetitorPriceAddressListComponent,
        EpbtFaCompetitorPriceTypeListComponent,
        EpbtFaQuickPurchaseSelectedProductGridComponent,
        EpbtFaProductPerListComponent,
        EpbtFaCompetitorSelectedProductGridComponent,
        EpbtFaCompetitorNegotiationListComponent,
        EpbtFaQuickPurchaseSummaryComponent,
        EpbtFaAddressesGridComponent,
        EpbtFaQuickOrderQuoteSelectedProductGridComponent,
        EpbtFaProductQuantityControlComponent,
        EpbtFaQuickOrderTalliedProductLineNegotiationComponent,
        EpbtFaQuickOrderMOLTNegotiationComponent,
        EpbtFaQuickOrderLineNegotiationComponent,
        EpbtFaCompetitorSummaryComponent,
        EpbtFaPerListComponent,
        EpbtFaProductTalliedQuantityControlComponent,
        EpbtFaCustomerInfoComponent,
        EpbtFaQuickTransferSummaryComponent,
        EpbtFaLabelRequestComponent,
        EpbtFaLabelTemplatesGridComponent,
        EpbtFaLabelSelectedProductsGridComponent,
        EpbtFaCompetitorPricingLineNegotiationComponent,
        EpbtFaQuickTransferSummaryProductsGridComponent,
        EpbtFaQuickPurchaseSummaryProductsGridComponent,
        EpbtFaProductFilesGridComponent,
        NoCommaPipe,
        EpbtFaQuickOrderSummaryComponent,
        EpbtFaLabelSummaryComponent,
        EpbtFaDashboardOpportunitiesGridComponent,
        EpbtFaLabelSummaryTemplatesGridComponent,
        EpbtFaCalendarComponent,
        EpbtFaSmartviewsComponent,
        EpbtFaQuickOrderEmailComponent,
        KeyValuePipePipe,
        EpbtFaSmartviewsGridComponent,
        EpbtFaSmartTilesComponent,
        EpbtFaSmartviewsDetailsComponent,
        EpbtFaLabelSummaryProductsGridComponent,
        EpbtFaSmartTilesDetailsComponent,
        EpbtFaFilterControlComponent,

        EpbtFaDocumentSourceMaterialGridComponent,
        EpbtFaDocumentProcessesGridComponent,
        EpbtFaDocumentFinishedProductsGridComponent,
        EpbtFaSortControlComponent,
        EpbtFaRightSideBarComponent,
        EpbtFaSortListComponent,
        EpbtFaNewQuickOrderCustomerComponent,
        EpbtFaNewQuickOrderProductComponent,
        EpbtFaNewQuickOrderCustomerDetailsComponent,
        EpbtFaNewQuickOrderProductDetailsComponent,
        EpbtFaNewQuickOrderDetailsComponent,
        EpbtFaNewQuickOrderOperationsComponent,
        EpbtFaSaleTypeListComponent,
        EpbtFaProductDialogComponent,
        EpbtFaOpenDocumentComponent
    ],
    providers: [
        {
            provide: API_BASE_URL,
            useFactory: serviceConfig_CloudApiEndpoint,
        },
        EpbtFieldAgentService
    ],
    entryComponents: [EpbtFaImageDialogComponent, EpbtFaRightSideBarComponent]
    // providers: [FieldAgentClient]
})
export class EpBtFieldAgentControlsModule {

    constructor(private injector: Injector) {
        InjectorInstance = this.injector;
    }
    // public static forRoot(): ModuleWithProviders {

    //     // let serviceConfig=new serviceConfig()
    //     return {
    //         ngModule: EpBtFieldAgentControlsModule,
    //         providers: [

    //             // { provide: 'environment', useValue: environment },
    //             // BistrackService,
    //             // ApiSessionService,
    //             // DataExchangeService,
    //             { provide: API_BASE_URL, useValue: this.serviceConfig.CloudApiEndpoint },
    //         ]
    //     };
    // }
}
